import io from "socket.io-client";
const socket = io("https://typemania.fly.dev");
// const socket = io("http://localhost:8080");
export default socket;
